<div><canvas baseChart
        [type]="'bar'"
        [datasets]="barsChartDatasets"
        [labels]="barsChartLabels"
        [options]="barsChartOptions"></canvas></div>
